/**
 * 选择关系和信物
 * */
import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import Scrollbar from 'react-scrollbars-custom';
import { Modal, Button, message } from 'antd';
import * as Map from 'immutable';
import HTTP from '../../script/service';
import { connect } from 'react-redux';
import './common.scss';
import { DDLoading } from '../globalPageStatus';
import Util from '../../script/util';
import Recharge from '../recharge/Recharge';
import AffinityConfirm from './AffinityConfirm';
import { _change_affinity_modal } from '../../../src/store/Action';
class AffinityDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      loading: false,
      propData: null,
      typeId: null,
      tokenId: null,
      otherUid: null,
      detail: {},
    };
  }
  // 是否更新数据
  componentDidUpdate(prevProps, prevState, snapshot) {
    const props1 = Map.fromJS(prevProps.base.affinityDetailModal);
    const props2 = Map.fromJS(this.props.base.affinityDetailModal);

    if (!this.props.base.affinityDetailModal && !Map.is(props1, props2)) {
      this.hideModal();
    } else if (this.props.base.affinityDetailModal && !Map.is(props1, props2)) {
      const otherUid = this.props.base.affinityDetailOtherUid;
      const propData = this.props.base.affinityInviteData;
      this.setState(
        {
          typeId: null,
          tokenId: null,
          propData,
          otherUid,
        },
        () => {
          this.getAffinityInfo();
        }
      );
    }
  }
  hideModal = () => {
    this.setState({
      visible: false,
    });
    _change_affinity_modal({
      affinityDetailModal: false,
      affinityDetailOtherUid: null,
    });
  };
  onChangeTypeTab = (typeId) => {
    this.setState({ typeId });
  };
  onChangeTokenTab = (tokenId) => {
    this.setState({ tokenId });
  };

  //获取关系邀请信息
  getAffinityInfo = () => {
    const { otherUid } = this.state;
    let params = {
      otherUid,
    };
    HTTP._get_affinity_invite_info(params).then((res) => {
      if (res.code == 200) {
        this.setState({ detail: res.data, visible: true });
      } else {
        message.error(res.message);
      }
    });
  };

  openRecharge = () => {
    this.rechargeElement.showModal();
  };

  onNext = () => {
    const { typeId, tokenId, detail, propData } = this.state;
    let typeInfo = detail?.relationList?.find(
      (e) => e.relationConfigId == typeId
    );
    let tokenInfo = detail?.goodsVoList?.find(
      (e) => e.propGoodsId == (propData?.id ? propData?.id : tokenId)
    );
    if (!typeInfo) {
      message.warning('请选择关系');
      return;
    }
    if (!tokenInfo) {
      message.warning('请选择信物');
      return;
    }
    const { otherAvatar, otherNickName, otherUid } = detail;
    let otherInfo = {
      avatar: otherAvatar,
      nickName: otherNickName,
      uid: otherUid,
    };
    this.affinityConfirmElement.showModal({ typeInfo, tokenInfo, otherInfo });
  };
  render() {
    const {
      base: { userInfo },
    } = this.props;
    const { loading, typeId, tokenId, detail, propData, visible } = this.state;
    return (
      <div className="affinity-modal">
        <Modal
          open={visible}
          zIndex={1003}
          wrapClassName="daidai-modal-style has-top-border"
          centered={true}
          title={propData ? `选择关系` : `选择关系和信物`}
          footer={null}
          keyboard={false}
          maskClosable={false}
          width="512px"
          onCancel={this.hideModal}
        >
          <DDLoading status={loading} className="set-plan-spin">
            <div className="affinity-modal-box">
              <Scrollbar
                ref={(el) => (this.scrollElement = el)}
                className="my-scroll-bar"
                style={{ height: '600px' }}
              >
                <div className="affinity-detail-cp">
                  <div className="affinity-detail-avatar">
                    <img
                      src={Util.transImgUrl(userInfo?.avatar, '50x50')}
                      alt=""
                    />
                  </div>
                  <i className="icon icon-line"></i>
                  <div className="affinity-detail-avatar">
                    <img
                      src={Util.transImgUrl(detail?.otherAvatar, '50x50')}
                      alt=""
                    />
                  </div>
                </div>
                <h3>请选择你要缔结的关系</h3>
                <div className="affinity-type">
                  {detail?.relationList?.map((item) => (
                    <div
                      key={item.relationConfigId}
                      className={`affinity-type-cell ${typeId == item.relationConfigId ? 'active' : ''}`}
                      onClick={() =>
                        this.onChangeTypeTab(item.relationConfigId)
                      }
                    >
                      <i
                        className="icon"
                        style={{
                          backgroundImage: `url('${Util.transImgUrl(item.relationConfigIcon)}')`,
                        }}
                      ></i>
                      <span>{item.relationConfigName}</span>
                    </div>
                  ))}
                </div>
                <h3 style={{ marginTop: '20px' }}>
                  {propData ? '缔结信物' : '请选择你们的信物'}
                </h3>
                <div className="affinity-token">
                  {propData ? (
                    <div className="affinity-token-detail">
                      <div className="affinity-token-detail-box">
                        <img
                          src={Util.transImgUrl(propData?.titlePic, '300x300')}
                          alt=""
                        />
                      </div>
                      <div className="affinity-token-detail-name">
                        <p>{propData?.name}</p>
                      </div>
                      <div className="affinity-token-detail-text">
                        <p>{propData?.remark}</p>
                        <p>{propData?.otherTip}</p>
                      </div>
                      <Button
                       className="daidai-btn-primary"
                        style={{ width: '250px', marginTop: '48px' }}
                        onClick={this.onNext}
                      >
                        下一步
                      </Button>
                    </div>
                  ) : (
                    detail?.goodsVoList?.map((item, index) => (
                      <div
                        key={item.id}
                        className={`affinity-token-item ${tokenId == item.propGoodsId ? 'active' : ''}`}
                        onClick={() => this.onChangeTokenTab(item.propGoodsId)}
                      >
                        {item?.rarityConfig ? (
                          <div className="affinity-token-rarity">
                            <img
                              src={Util.transImgUrl(
                                item?.rarityConfig?.labelImg
                              )}
                              alt=""
                            />
                          </div>
                        ) : null}
                        <div className="affinity-token-cover">
                          <img
                            src={Util.transImgUrl(item.prePic, '150x150')}
                            alt=""
                          />
                        </div>
                        <div className="affinity-token-name">
                          {item.goodsName}
                        </div>
                        <div className="affinity-token-price">
                          {item.intimateType == 0 ? (
                            '已拥有'
                          ) : (
                            <>
                              <i className="icon icon-diamond"></i>
                              <span>{item.skuPrice}</span>
                            </>
                          )}
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </Scrollbar>
              {propData ? null : (
                <div className="affinity-action">
                  <div className="affinity-action-left">
                    <i className="icon icon-diamond"></i>
                    <span>{userInfo?.diamondAmount || 0}</span>
                    <i
                      className="icon icon-add"
                      onClick={this.openRecharge}
                    ></i>
                  </div>
                  <div className="affinity-action-right">
                    <Button
                      className="daidai-btn-primary"
                      onClick={this.onNext}
                    >
                      下一步
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </DDLoading>
        </Modal>
        {/* 充值模块 */}
        <Recharge
          wrappedComponentRef={(el) => (this.rechargeElement = el)}
          base={this.props.base}
        />
        <AffinityConfirm
          wrappedComponentRef={(el) => (this.affinityConfirmElement = el)}
          base={this.props.base}
        />
      </div>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(AffinityDetail, { withRef: true })
);
